import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";

const firebaseConfig = {
  projectId: "humaizer-project",
  appId: "1:949521861086:web:619e2c9817468a2443754f",
  apiKey: "AIzaSyBZ-yiJZLxF0alLKUHvYVgdliVAuqznxA4",
  authDomain: "humaizer-project.firebaseapp.com",
  storageBucket: "humaizer-project.firebasestorage.app",
  messagingSenderId: "949521861086",
  measurementId: ""
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
}, "ai-studio-14cd1a3f-1f99-422a-b9fc-ba2504708416");
export const googleProvider = new GoogleAuthProvider();
